<div
  *ngIf="tenant; else notenant"
  [nbPopover]="popover"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'bottom'">
  {{tenant.name}}
</div>

<ng-template #notenant>
  <div class="no-tenant">kein Kunde</div>
</ng-template>

<ng-template #popover>
  <wr-tenant-popover [tenant]="tenant" [disableLink]="disableLink"></wr-tenant-popover>
</ng-template>
